import { z } from "zod";
import { vehicleTypeSchema } from "../_shared";

export const getVehiclesDetailsByUuidsResponse = z.array(
  z.object({
    uuid: z.uuid(),
    registrationNumber: z.string().nullable(),
    model: z.string().nullable(),
    vehicleType: vehicleTypeSchema,
    companyName: z.string(),
    dateMec: z.iso.datetime().nullable(),
  }),
);

export type GetVehiclesDetailsByUuidsResponse = z.infer<
  typeof getVehiclesDetailsByUuidsResponse
>;
